module.exports = __webpack_public_path__ + "img/blank.25b8d0f1.png";